import { FormContext, FormErrorTypes } from 'dash-ui';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  isDescriptionLengthValid,
  isUrlValid,
  DashValidation,
  isNameLengthValid,
} from 'dash-common';
import { FormFields } from 'pages/authentication/complete-sign-up-scope/AddAdditionalInfoPage/component/AddAdditionalInfoForm/constants/constants';

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  const validateFieldByName = (
    fieldName: FormFields,
    value: string | Array<{ _id: string }>
  ) => {
    const setInvalid = (message: string, values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        // @ts-ignore
        message: t(message, values),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.AgencyName: {
        if (value) {
          if (!isNameLengthValid(value as string)) {
            setInvalid('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            });
            return false;
          }
        }
        break;
      }
      case FormFields.AgencyWebsite: {
        if (value && !isUrlValid(value as string)) {
          setInvalid('forms:messages.urlInvalid');
          return false;
        }
        break;
      }
      case FormFields.ShortDescription: {
        const desc = value as string;
        if (desc && !isDescriptionLengthValid(desc)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxDescriptionLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.Place: {
        if (!value) {
          setInvalid('forms:messages.addressBlank');
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
